import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import { StatisticRow } from './StatisticRow';
import { Button } from '@kizen/kds/Button';
import { Link } from 'react-router-dom';

type ObjectCardProps = {
  object: any;
  fieldStats: any;
  recordStats: any;
};

export const ObjectCard = (props: ObjectCardProps) => {
  const { object, recordStats, fieldStats } = props;

  return (
    <div
      className={`relative border-1 rounded-lg p-4 flex flex-col border-border-medium overflow-hidden`}
    >
      <div className="flex items-center justify-between w-full">
        <Typography truncate>{object.name}</Typography>
        <Link to={`/custom-objects/${object.api_name}`} target="_blank">
          <Button
            variant="text"
            size="small"
            rightIcon="action-open"
            color="secondary"
            rightIconSettings={{
              tooltipEnabled: false,
            }}
          />
        </Link>
      </div>
      <Spacer size={20} />
      <StatisticRow label={'Records'} small {...recordStats} />
      <Spacer size={20} />
      <StatisticRow label={'Fields'} small {...fieldStats} />
    </div>
  );
};
